const resources = [
  'expert-chat-fab-team.png',
  'expert-chat-fab-bubble-purple.png',
  'expert-chat-fab-bubble-black.png',
  'expert-chat-fab-team-text.png',
  'expert-chat-welcome-team.jpg',
].reduce(
  (accumulator, resource) => ({
    ...accumulator,
    [resource]: require(`./${resource}`),
  }),
  {}
);

export default resources;



// WEBPACK FOOTER //
// ./packages/smart-home-support/assets/resources/SHS-ASURION/index.ts